import * as mainModule from './main.js';

import Main from '../dev-launcher/__compiled/ui-behaviour.js';
mainModule.mod._ValueClass = Main;

export default mainModule.LCHPackage();
